import styled from 'styled-components';
import { colors } from '@everlywell/leaves';

const Layout = styled.div.attrs(props => ({
  fadeIn: props.fadeIn,
}))`
  display: flex;
  flex-direction: column;
  margin-top: 56px;

  *:focus {
    outline-color: ${colors.teal4};
  }
`;

export { Layout };
